import { type AssetResponse } from '@on3/api';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { getAssetUrl } from '@on3/ui-lib/utils/images';

interface ISiteAvatar extends React.ImgHTMLAttributes<HTMLImageElement> {
  type?: 'default' | 'team' | 'alternate';
  asset?: AssetResponse;
}

/** Renders a fan site avatar */
export const FanSiteAvatar = ({
  type = 'default',
  asset,
  ...props
}: ISiteAvatar) => {
  const { currentSite } = useSite();

  const teamAsset = currentSite.organization?.defaultAssetRes;
  const defaultAsset = currentSite.defaultAvatar;
  const alternateAsset = currentSite.alternateAvatar;

  const selectedAsset =
    type === 'team'
      ? teamAsset
      : type === 'alternate'
        ? alternateAsset
        : defaultAsset;

  const source =
    getAssetUrl(asset || selectedAsset) ||
    'https://on3static.com/teams/default.svg';

  const siteName =
    currentSite?.organization?.knownAs ?? currentSite?.organization?.name ?? '';

  return (
    <img
      alt={siteName}
      loading="lazy"
      src={source}
      title={siteName}
      {...props}
    />
  );
};
